import { styled } from "@linaria/react";
import { colors, fonts } from "@ui/Theme";

export const Label = styled.div`
  color: ${colors.carbon800};
  font: ${fonts.body1SemiBold};
  display: flex;
  align-items: center;
`;
